import type { TNavbarMenuListElement } from '@shared/dream-components';
import { NavbarMenuList as NavbarMenuListElement } from '@shared/dream-components';
import type { ReactNode } from 'react';

interface Props {
  node: TNavbarMenuListElement;
  children: ReactNode | ReactNode[];
  screen: 'desktop' | 'mobile';
}

const NavbarMenuList = ({ node, children, screen }: Props) => {
  return (
    <NavbarMenuListElement element={node} screen={screen}>
      {children}
    </NavbarMenuListElement>
  );
};

export default NavbarMenuList;
